import { Pencil, Trash2, Smartphone, Check, X } from 'lucide-react';
import { QrcodeCoupon } from '../../types/qrcode';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeader,
  TableRow,
  Button,
  Badge,
  EmptyState,
} from '../ui';
import { formatPhone } from '../../types/api';

interface QrcodeCouponListProps {
  coupons: QrcodeCoupon[];
  onEdit: (coupon: QrcodeCoupon) => void;
  onDelete: (coupon: QrcodeCoupon) => void;
  isLoading?: boolean;
}

function QrcodeCouponList({ coupons, onEdit, onDelete, isLoading }: QrcodeCouponListProps) {
  if (isLoading) {
    return (
      <div className="flex justify-center py-8">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (coupons.length === 0) {
    return (
      <EmptyState
        icon={<Smartphone className="h-12 w-12" />}
        title="Nenhum cupom encontrado"
        description="Adicione cupons para este QR Code"
      />
    );
  }

  return (
    <TableContainer>
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>ID do Cupom</TableHead>
            <TableHead>Telefone</TableHead>
            <TableHead>Status</TableHead>
            <TableHead>Data de Criação</TableHead>
            <TableHead className="relative">
              <span className="sr-only">Ações</span>
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {coupons.map(coupon => (
            <TableRow key={coupon.id}>
              <TableCell className="font-mono text-xs">{coupon.coupon_uid}</TableCell>
              <TableCell>{coupon.phone ? formatPhone(coupon.phone) : '-'}</TableCell>
              <TableCell>
                <Badge
                  variant={coupon.processed ? 'success' : 'warning'}
                  className="flex items-center gap-1"
                >
                  {coupon.processed ? (
                    <>
                      <Check className="h-3 w-3" />
                      Processado
                    </>
                  ) : (
                    <>
                      <X className="h-3 w-3" />
                      Pendente
                    </>
                  )}
                </Badge>
              </TableCell>
              <TableCell>{new Date(coupon.created_at).toLocaleString()}</TableCell>
              <TableCell className="text-right space-x-2">
                <Button variant="ghost" onClick={() => onEdit(coupon)} title="Editar">
                  <Pencil className="h-4 w-4" />
                </Button>
                <Button variant="ghost" onClick={() => onDelete(coupon)} title="Excluir">
                  <Trash2 className="h-4 w-4 text-red-600" />
                </Button>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default QrcodeCouponList;
